import { Link } from "react-router-dom";
import { Star, ArrowUpRight } from "lucide-react";
import { Reveal, LineReveal } from "@/components/Reveal";
import GoogleReviewsBadge from "@/components/GoogleReviewsBadge";
import { TESTIMONIALS, IMAGES } from "@/lib/data";

const MORE = [
  { name: "Klaus B.", car: "1957 BMW 507", rating: 5, quote: "Ein Gutachten, das jedes Detail meines 507er würdigt. Ich habe selten so viel Sachverstand erlebt.", image: "porsche" },
  { name: "Sabine M.", car: "1972 Alfa Romeo Spider", rating: 5, quote: "Wir haben unseren Alfa nach dem Tod meines Vaters begutachten lassen — mit sehr viel Feingefühl und Kompetenz.", image: "mercedes" },
  { name: "Thomas R.", car: "1978 Cadillac Eldorado", rating: 5, quote: "Von der ersten Kontaktaufnahme bis zur Abholung des Gutachtens: Alles hat einwandfrei funktioniert.", image: "jaguar" },
];

export default function References() {
  const all = [...TESTIMONIALS, ...MORE];
  return (
    <div data-testid="references-page" className="bg-[color:var(--cream)]">
      <section className="pt-40 lg:pt-48 pb-20 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px]">
          <div className="eyebrow mb-6">— Referenzen</div>
          <LineReveal
            className="display-xl text-6xl md:text-7xl lg:text-[7.5vw] leading-[0.92]"
            lines={["Stimmen unserer", "Halterinnen", "und Halter."]}
          />
          <p className="mt-10 text-[color:var(--ink-2)] max-w-2xl text-lg leading-relaxed">
            Vertrauen entsteht durch Erfahrung. Hier sprechen Menschen, deren Klassiker wir bewerten durften.
          </p>
          <div className="mt-10"><GoogleReviewsBadge /></div>
        </div>
      </section>

      <section className="pb-32 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px] grid grid-cols-1 md:grid-cols-2 gap-6">
          {all.map((t, i) => (
            <Reveal key={i} delay={(i % 2) * 0.1}>
              <article className={`border border-black/10 p-10 h-full flex flex-col ${i % 3 === 0 ? "bg-[color:var(--cream-2)]" : ""}`}>
                <div className="flex gap-1 text-[color:var(--burgundy)]">
                  {[...Array(t.rating)].map((_, j) => <Star key={j} className="h-4 w-4 fill-current" />)}
                </div>
                <blockquote className="font-serif text-2xl md:text-3xl leading-[1.25] mt-8 flex-1">{`„${t.quote}"`}</blockquote>
                <div className="mt-10 pt-6 border-t border-black/10 flex items-center gap-5">
                  <div className="w-16 h-16 overflow-hidden bg-black shrink-0">
                    <img src={IMAGES[t.image]} alt={t.car} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="font-medium">{t.name}</div>
                    <div className="text-sm italic text-[color:var(--ink-2)]">{t.car}</div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px] flex flex-col md:flex-row justify-between items-start md:items-center gap-6 border-t border-black/15 pt-10">
          <div className="font-serif text-3xl md:text-4xl max-w-xl">Werden Sie unser <em className="italic">nächster zufriedener Kunde.</em></div>
          <Link to="/kontakt" className="btn-primary" data-testid="references-cta">Kontakt aufnehmen <ArrowUpRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
